import schema from './schemaVersions/v2.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;